import React, { SelectHTMLAttributes } from 'react';

interface OpcaoSelect {
  valor: string;
  label: string;
}

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  opcoes: OpcaoSelect[];
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  onValueChange?: (valor: string) => void;
  valor?: string;
  value?: string; // Adicione esta linha
  className?: string;
  placeholder?: string;
  label?: string;
  id?: string;
  error?: string;
}

const Select: React.FC<SelectProps> = ({
  opcoes,
  onChange,
  onValueChange,
  valor,
  value, // Adicione esta linha
  className = '',
  placeholder = 'Selecione uma opção',
  label,
  id,
  error,
  ...rest
}) => {
  // Use value se disponível, caso contrário use valor
  const selectedValue = value !== undefined ? value : valor;

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (onChange) {
      onChange(event);
    }
    if (onValueChange) {
      onValueChange(event.target.value);
    }
  };

  const selectId = id || `select-${Math.random().toString(36).substring(2, 9)}`;

  return (
    <div className="relative w-full">
      {label && (
        <label htmlFor={selectId} className="block text-text text-sm font-medium mb-1">
          {label}
        </label>
      )}
      <div className="relative">
        <select
          id={selectId}
          value={selectedValue ?? ''} // Use o valor combinado
          onChange={handleSelectChange}
          className={`
            block w-full
            py-2 px-3 pr-10
            bg-background text-text
            border ${error ? 'border-red-500' : 'border-primary/20'} rounded-md
            shadow-sm
            focus:outline-none focus:ring-2 focus:ring-accent focus:border-primary/20
            appearance-none
            transition ease-in-out duration-150
            cursor-pointer
            ${className}
          `}
          {...rest}
        >
          {placeholder && (
            <option value="" disabled hidden>
              {placeholder}
            </option>
          )}
          {opcoes.map((opcao) => (
            <option key={opcao.valor} value={opcao.valor}>
              {opcao.label}
            </option>
          ))}
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2">
          <svg
            className="h-5 w-5 text-secondary"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </div>
      </div>
      {error && (
        <p className="mt-1 text-sm text-red-500">{error}</p>
      )}
    </div>
  );
};

export default Select;